import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  style,
} from '@angular/animations';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreLoadingScreenService {
  loadingScreenEl: any;
  loadingMessageEl: any;
  animationPlayer: AnimationPlayer;
  showInnerLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  showLoader = this.showInnerLoader.asObservable();

  /** Whether the loading screen is currently shown (set by show(), cleared by hide()). */
  isVisible = false;

  /**
   * Constructor
   *
   * @param _document
   * @param _router
   * @param _animationBuilder
   */
  constructor(
    @Inject(DOCUMENT) private _document: any,
    private _router: Router,
    private _animationBuilder: AnimationBuilder
  ) {
    // Initialize
    this._init();
  }

  // Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    // Get the loading screen element

    this.loadingScreenEl = this._document.body.querySelector('#loading-bg');
    this.loadingMessageEl = this._document.body.querySelector('#loading-message');
    if (this.loadingScreenEl) {
      this.hide();
    }
    // If loading screen element
  }

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Show the loading screen
   *
   * @param message Optional message displayed below the spinner. If omitted or empty, no message is shown.
   */
  show(message?: string): void {
    this.isVisible = true;
    this._setMessage(message);

    this.animationPlayer = this._animationBuilder
      .build([
        style({
          opacity: '0',
          zIndex: '99999',
        }),
        animate('250ms ease', style({ opacity: '1' })),
      ])
      .create(this.loadingScreenEl);

    setTimeout(() => {
      this.animationPlayer.play();
    }, 0);
  }

  /**
   * Hide the loading screen
   */
  hide(): void {
    this.isVisible = false;
    this._setMessage(null);

    this.animationPlayer = this._animationBuilder
      .build([
        style({ opacity: '1' }),
        animate(
          '250ms ease',
          style({
            opacity: '0',
            zIndex: '-10',
          })
        ),
      ])
      .create(this.loadingScreenEl);

    setTimeout(() => {
      // this.loadingScreenEl.remove();
      this.animationPlayer.play();
    }, 0);
  }

  displayInnerLoader() {
    this.showInnerLoader.next(true);
  }
  hideInnerLoader() {
    this.showInnerLoader.next(false);
  }

  /**
   * Set or clear the message shown below the spinner without replaying the
   * show/hide animation. Used to (re)compute the message while the spinner
   * is already visible and requests are still in flight (e.g. overlapping
   * requests where only some of them are uploads).
   *
   * @param message Optional message to display. If omitted or empty, the message is hidden.
   */
  updateMessage(message?: string): void {
    this._setMessage(message);
  }

  /**
   * Set or clear the message shown below the spinner.
   *
   * @private
   */
  private _setMessage(message?: string): void {
    if (!this.loadingMessageEl) {
      return;
    }

    if (message) {
      this.loadingMessageEl.textContent = message;
      this.loadingMessageEl.style.display = 'block';
    } else {
      this.loadingMessageEl.textContent = '';
      this.loadingMessageEl.style.display = 'none';
    }
  }
}
